import ContactItem from '../Components/ContactItem';
import React from 'react'
import Tittle from '../Components/Tittle';
import email from '../img/emailme.svg';

function ContactPage() {
    return (
        <div>
            <div className="title">
                <Tittle title={'Contact Me'} span={'Contact Me'} />
            </div>
            <div className="ContactPage">
                <div className="contact-sect">
                    <ContactItem icon={email} text1={'babettsan@gmail.com'} text2={''} title={'Email'} link={'mailto:babettsan@gmail.com'} />
                    <ContactItem icon={email} text1={'linkedin.com/in/babettsan'} text2={''} title={'LinkedIn'} link={'https://www.linkedin.com/in/babettsan'} />
                    <ContactItem icon={email} text1={'github.com/babettsan'} text2={''} title={'GitHub'} link={'https://github.com/babettsan'} />
                </div>
            </div>
        </div>
    )
}

export default ContactPage;
